import { render, staticRenderFns } from "./SmallModal.vue?vue&type=template&id=2bf16578&scoped=true&"
import script from "./SmallModal.vue?vue&type=script&lang=js&"
export * from "./SmallModal.vue?vue&type=script&lang=js&"
import style0 from "./SmallModal.vue?vue&type=style&index=0&id=2bf16578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf16578",
  null
  
)

export default component.exports